import React from 'react';
import { Lock, Plus } from 'lucide-react';
import { useTranslation } from '../../../../contexts/LanguageContext';

const MobileCreateSpaceButton = ({ 
  isPremium, 
  spacesCount, 
  maxFreeSpaces,
  onClick,
  onUpgrade 
}) => {
  const { t } = useTranslation();

  return (
    <div 
      className="flex flex-col items-center cursor-pointer order-first"
      onClick={!isPremium && spacesCount >= maxFreeSpaces ? onUpgrade : onClick}
    >
      <div className={`
        w-20 h-20 rounded-full flex items-center justify-center
        ${!isPremium && spacesCount >= maxFreeSpaces 
          ? 'bg-gray-100 text-gray-400 border-2 border-dashed border-gray-300' 
          : 'bg-[#253985] text-white hover:bg-[#1a2c6d]'}
        shadow-md relative transition-colors
      `}>
        <Plus className={`h-8 w-8 ${!isPremium && spacesCount >= maxFreeSpaces ? 'opacity-60' : ''}`} />
        {!isPremium && spacesCount >= maxFreeSpaces && (
          <Lock className="h-5 w-5 absolute top-1 right-1 text-gray-400" />
        )}
      </div>
      <div className={`mt-2 text-sm font-medium ${!isPremium && spacesCount >= maxFreeSpaces ? 'text-gray-500' : 'text-gray-800'}`}>
        {!isPremium && spacesCount >= maxFreeSpaces 
          ? t('sharesubs.createSpaceButton.upgradeToAddMore') 
          : t('sharesubs.createSpaceButton.newSpace')}
      </div>
    </div>
  );
};

export default MobileCreateSpaceButton;